var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gauge-chart-situation"},[_c('div',{staticClass:"gauge-chart-box",attrs:{"id":'gaugeChart' + _vm.timeId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }